import _ from "../../../../utils/underscore";
import Device from '../../../../utils/device/device';
import {FEATURE_CB_FUNC, KEY_NAME, SERIVCES_FUNC_LIST} from "../../native/native_const";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS, USER_EVENTS} from "../../../../events/events";
import DOM from "../../../../utils/dom";
import BaseObject from "../../../../base/base_object";




const GAME_SUPPORTED_NYX = 'NYX';
const TIME_OUT_GAME_LOAD = 30;
const CB_FN = 'cbfn';

/**
 *
 *
 */
class LobbyPopUp extends BaseObject{
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'LobbyPopUp';
    _HybridService = null;
    _bEnable = false;
    _nPreviosHeight = 0;
    _bLobbyPopUpSupport = false;
    _popUpTimeOut = null;
    _dataObjSrc = null;
    _onResizeEvent = null;

    _nCountInterval = 0;
    _resizeInterval = null;
    _left = -1;
    _right = -1;
    _top = -1;
    _bottom = -1;
    _timeout=0;


    init(params) {

        super.init();


        if(_.isNullOrUndefined(params)){
            return;
        }

        if (Device.hybrid.isEmbedded) {
            params = params.ios;
        }

        if(!_.isNullOrUndefined(params) && params.enable){

            this._bEnable = true;
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._bEnable){
            this._HybridService.isPopUpAboveSecounpSupported().then(data => {
                this._bLobbyPopUpSupport = true;
                this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.LOBBY_POPUP_SET_CB, FEATURE_CB_FUNC.HYBRID_LOBBY_POP_UP_CALL);
            });
        }

        this._subscribe();

        return this;
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.SHOW_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW, this._onShow, this);
        Event.on(SYSTEM_EVENTS.CLOSE_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW, this._onClose, this);
    }


    onHybridDirectCall(data) {
        this._executeFunc(data);
    }

    _executeFunc(data) {
        let fn = this.getFuncName(data);

        if('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    getFuncName(data) {
        let fn = data[CB_FN];

        return (undefined !== fn) ? fn : '';
    }

    _getContent(){
        if(null !== this._dataObjSrc) {
            this._onShow(this._dataObjSrc);
        }
    }

    _getParams(dataObj) {

        if (_.isNullOrUndefined(dataObj) || _.isNullOrUndefined(dataObj.content)) {
            return null;
        }

        let rect = null;
        let msgObj = null;
        let content = document.querySelector(dataObj.content);

        if (content) {
            rect = content.getBoundingClientRect();
            if (rect) {
                 msgObj = {
                    height: window.outerHeight,
                    width: window.outerWidth,
                    rectwidth: rect.width,
                    rectheight: rect.height,
                    left: rect.x,
                    right: window.outerWidth - rect.width - rect.x,
                    top: rect.y,
                    bottom: window.outerHeight - rect.height - rect.y,
                    timeout: 0,
                    showHybridPopUp: dataObj.showHybridPopUp,
                    isFirstShow: dataObj.isFirstShow
                };
            }
        }
        return msgObj;
    }

    _onShow(dataObj) {

        const msgObj = this._getParams(dataObj);

        this._timeout = 300;
        if(msgObj.isFirstShow) {
            this._timeout = dataObj.timeout * 1;
        }

        this.clearTimeOut();

        this._popUpTimeOut = DOM.setTimeout(() => {
            this._onShowTimeOut(dataObj);
        },  this._timeout);

    }

    async _onShowTimeOut(dataObj) {

        const msgObj = this._getParams(dataObj);

        if(!await this.isGameOpenAndSupportLobbyPopUp(msgObj)){
            if(true === msgObj.isFirstShow){
                Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL);
                return;
            }
        }

        if(msgObj.isFirstShow) {
            this._dataObjSrc = dataObj;
            this._onResizeEvent = DOM.addEventListener(window, USER_EVENTS.ON_RESIZE, this._onResize.bind(this), false);
        }

        //the popup size is not correct yet
        if(msgObj.rectwidth > msgObj.width || msgObj.rectheight > msgObj.height) {
            return;
        }

        this._nPreviosHeight = msgObj.height;

        this._left = msgObj.left;
        this._right = msgObj.right;
        this._top = msgObj.top;
        this._bottom = msgObj.bottom;


        let data = {[KEY_NAME.LEFT]: msgObj.left, [KEY_NAME.RIGHT]: msgObj.right, [KEY_NAME.TOP]: msgObj.top,[KEY_NAME.BOTTOM]: msgObj.bottom,
            [KEY_NAME.SHOW]: msgObj.isFirstShow.toString() , [KEY_NAME.TIME_OUT]: msgObj.timeout, [KEY_NAME.TIME_OUT_BEFORE_DISPLAY]:TIME_OUT_GAME_LOAD};

        this._HybridService.popUpAboveSecoundShow(data);

    }

    _isValid(newParam, oldParam, val){

        return val && (newParam !== oldParam) && oldParam > 0;
    }

    _isPopUpReady(){
        const msgObj = this._getParams(this._dataObjSrc);

        let bValid = this._isValid(this._top, msgObj.top, true);
        bValid = this._isValid(this._left, msgObj.left, bValid);
        bValid = this._isValid(this._right, msgObj.right, bValid);
        bValid = this._isValid(this._bottom, msgObj.bottom, bValid);

        return bValid;
    }

    _onResize(){
        this._dataObjSrc.isFirstShow = false;

        let self = this;
        this._nCountInterval = 0;

         DOM.setTimeout(() => {
             self._resizeInterval = setInterval(function(){
                 let bClearInterval = 10 < ++self._nCountInterval;//wait maximum 1 sec
                 let bCheckReady = self._isPopUpReady();
                 if(bCheckReady){
                     self._onShow(self._dataObjSrc);
                     bClearInterval = true;
                 }

                 if(bClearInterval && null !== self._resizeInterval) {
                     clearInterval(self._resizeInterval);
                     self._resizeInterval = null;
                 }
             }, 100);
         }, 300);

    }

    async isGameOpenAndSupportLobbyPopUp(msgObj){

        const gameSupported = GAME_SUPPORTED_NYX === (await this._HybridService.serviceFactory.gameService().getCurrentRunningGamecompanyName())?.toUpperCase();

        if (!msgObj || !this._bLobbyPopUpSupport || !msgObj.showHybridPopUp || !gameSupported) {
            return false;
        }

        return true;
    }

    _onClose(){

        this._nPreviosHeight = 0;
        this._HybridService.popUpAboveSecoundClose();
        this._onResizeEvent && this._onResizeEvent.remove();
        this._dataObjSrc = null;
        clearInterval(this._resizeInterval);
        this._resizeInterval = null;

    }

    clearTimeOut() {
        if (this._popUpTimeOut) {
            DOM.clearTimeout(this._popUpTimeOut);
            this._popUpTimeOut = null;
        }
    }

}

//TEST_ORBIT_POPUP

export default LobbyPopUp;
